import httpClient from "./httpClient";

// Bell/in-app notifications all live under the "notification_center" delivery channel — the
// header bell and the full Notification Center page are two views over the same read state.
export const BELL_CHANNEL = "notification_center";

export const getUserNotifications = ({ module, channel = BELL_CHANNEL, isRead, search, page = 0, size = 10 }) =>
  httpClient.get(`/api/notifications/users/user`, {
    params: { module, channel, isRead, search: search || undefined, page, size },
  });

export const getUnreadCount = (channel = BELL_CHANNEL) =>
  httpClient.get(`/api/notifications/users/user/unread-count`, {
    params: { channel },
  });

export const markNotificationRead = (id) =>
  httpClient.patch(`/api/notifications/users/${id}/read`);

export const markNotificationUnread = (id) =>
  httpClient.patch(`/api/notifications/users/${id}/unread`);

export const markAllNotificationsRead = (channel = BELL_CHANNEL) =>
  httpClient.patch(`/api/notifications/users/user/read-all`, null, {
    params: { channel },
  });
